import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../../../atoms/Icon'
import { getStatusStyle } from '../helpers'
import useStatusImageUrl from '../hooks/useStatusImageUrl'

function PlanStatusIcon ({ status, size, statusStyleOverrides }) {
  const style = getStatusStyle(status, statusStyleOverrides)
  const wrapperSize = size + 10
  const imageUrl = useStatusImageUrl(style)

  // If the status has a custom image (resolved via media service or external URL),
  // render it instead of the MUI icon — mirrors the legacy StatusReportStatusIcon.
  // Keeps the same colored rounded wrapper as the MUI fallback so the visual
  // language stays consistent.
  if (imageUrl) {
    return (
      <span
        title={status}
        className='flex items-center justify-center radius-md'
        style={{
          display: 'inline-flex',
          width: `${wrapperSize}px`,
          height: `${wrapperSize}px`,
          padding: '5px',
          backgroundColor: `color-mix(in srgb, ${style.color} 30%, white)`,
          flexShrink: 0
        }}
      >
        <img
          src={imageUrl}
          alt={status || 'Status icon'}
          style={{ width: `${size}px`, height: `${size}px`, objectFit: 'contain', display: 'block' }}
        />
      </span>
    )
  }

  return (
    <span
      title={status}
      className='flex items-center justify-center radius-md'
      style={{
        display: 'inline-flex',
        width: `${wrapperSize}px`,
        height: `${wrapperSize}px`,
        padding: '5px',
        backgroundColor: `color-mix(in srgb, ${style.color} 30%, white)`,
        flexShrink: 0
      }}
    >
      <Icon name={style.icon} customSize={size} color={style.color} />
    </span>
  )
}

PlanStatusIcon.propTypes = {
  status: PropTypes.string,
  size: PropTypes.number,
  statusStyleOverrides: PropTypes.object
}

PlanStatusIcon.defaultProps = {
  size: 20
}

export default PlanStatusIcon
